import { useGlobal } from '../useGlobal';

export const useLocale = () => {
	const { locale, setLocale } = useGlobal();

	return { locale, setLocale };
};
